function getColorForKey(key) {
  const colors = {
    "1": "#e8212d",
    "2": "#d09f2d",
    "3": "#2b9b4a",
    "4": "#C42738",
    "5": "#EC422B",
    "6": "#00ACD8",
    "7": "#FBB618",
    "8": "#972E47",
    "9": "#F16E25",
    "10": "#DE1C84",
    "11": "#F79C27",
    "12": "#CE8C2D",
    "13": "#507A47",
    "14": "#007CBA",
    "15": "#3BAE4A",
    "16": "#00578B",
    "17": "#183668"
  };
  return colors[key];
}

function cleanText(text) {
  var text = text.replace(/(\r\n|\n|\r)/gm, " ")
    .replace(/"/g, "'");
  return text;

}

//CONSTRUIR ODS IMAGENES
const odsImages = [];
for (let n = 1; n <= 17; n++) {
  odsImages.push({ src: `ods-${n}`, alt: `ODS ${n}`, key: `ods-${n}` });
}
odsImages.push({ src: "ods", alt: "ODS", key: "ods" });

export { getColorForKey, cleanText, odsImages}